import { HttpResponse, http } from 'msw';

import { environment } from '../../environments/environment';
const env = { ...environment };
const module = env.services.storeAvailableAdjustmentRequest;
const envServiceUrl = module.url;

const getStoreAvailableViewResolver = () => {
  return HttpResponse.json({
    version: 0,
    docNo: 'SB24-QAPOOKKY-0000131',
    refDoc: 'SU24-000476',
    storeCode: 'QAPOOKKY',
    storeName: 'PookkyShop',
    storeCodeName: 'QAPOOKKY-PookkyShop',
    noOfItems: 4,
    noOfCancelledItems: null,
    adjustItems: [
      {
        articleNo: '12101606',
        productName: 'สไปรท์ขวดแก้ว',
        adjustAvailableStock: -8,
        status: 'AWAITING_APPROVAL',
        remarkType: null,
        remarkRefDoc: null
      },
      {
        articleNo: '12101605',
        productName: 'แฟนต้าน้ำส้มขวดแก้ว',
        adjustAvailableStock: -26,
        status: 'AWAITING_APPROVAL',
        remarkType: null,
        remarkRefDoc: null
      },
      {
        articleNo: '12101603',
        productName: 'แฟนต้าน้ำเขียวขวดแก้ว',
        adjustAvailableStock: -8,
        status: 'AWAITING_APPROVAL',
        remarkType: null,
        remarkRefDoc: null
      },
      {
        articleNo: '12101604',
        productName: 'แฟนต้าน้ำแดงขวดแก้ว',
        adjustAvailableStock: -224,
        status: 'AWAITING_APPROVAL',
        remarkType: null,
        remarkRefDoc: null
      }
    ],
    status: 'AWAITING_APPROVAL',
    approvalFlowId: '67342b5f9ab0425f2397092a',
    currentApprovals: ['000003', '000061', '000028', '000044', '000092', '000031', '000255', '000034', '000081'],
    requestedDate: '2024-11-13T04:30:23.635Z',
    requestedBy: 'Pk Qa',
    auditLogs: [
      {
        activity: 'Created',
        description: null,
        editDate: '2024-11-13T04:30:23.403Z',
        editBy: '000031',
        editByName: 'Pk Qa'
      }
    ]
  });
};
const getStoreAvailableListResolver = () => {
  return HttpResponse.json({
    content: [
      {
        requestNo: 'SB24-QAPOOKKY-0000131',
        refDoc: 'SU24-000476',
        storeCode: 'QAPOOKKY',
        storeName: 'PookkyShop',
        storeCodeName: 'QAPOOKKY-PookkyShop',
        noOfItems: 4,
        requestedBy: 'Pk Qa',
        requestedDate: '2024-11-13T04:30:23.635Z',
        status: 'AWAITING_APPROVAL',
        auditLogs: [
          {
            activity: 'Created',
            description: null,
            editDate: '2024-11-13T04:30:23.403Z',
            editBy: '000031',
            editByName: 'Pk Qa'
          }
        ]
      },
      {
        requestNo: 'SB24-QAPOOKKY-000012',
        refDoc: 'SU24-000475',
        storeCode: 'QAPOOKKY',
        storeName: 'PookkyShop',
        storeCodeName: 'QAPOOKKY-PookkyShop',
        noOfItems: 4,
        requestedBy: 'Pk Qa',
        requestedDate: '2024-11-13T04:16:00.202Z',
        status: 'CANCELLED',
        auditLogs: [
          {
            activity: 'Cancelled',
            description: '',
            editDate: '2024-11-13T04:30:23.628Z',
            editBy: '000000',
            editByName: 'System'
          },
          {
            activity: 'Created',
            description: null,
            editDate: '2024-11-13T04:16:00.069Z',
            editBy: '000031',
            editByName: 'Pk Qa'
          }
        ]
      },
      {
        requestNo: 'SB24-QAPOOKKY-000011',
        refDoc: 'SU24-000452',
        storeCode: 'QAPOOKKY',
        storeName: 'PookkyShop',
        storeCodeName: 'QAPOOKKY-PookkyShop',
        noOfItems: 1,
        requestedBy: 'Pk Qa',
        requestedDate: '2024-11-13T04:00:49.978Z',
        status: 'AWAITING_APPROVAL',
        auditLogs: [
          {
            activity: 'Created',
            description: null,
            editDate: '2024-11-13T04:00:49.252Z',
            editBy: '000031',
            editByName: 'Pk Qa'
          }
        ]
      },
      {
        requestNo: 'SB24-QAPOOKKY-000010',
        refDoc: 'SU24-000454',
        storeCode: 'QAPOOKKY',
        storeName: 'PookkyShop',
        storeCodeName: 'QAPOOKKY-PookkyShop',
        noOfItems: 1,
        requestedBy: 'Pk Qa',
        requestedDate: '2024-11-12T10:24:14.308Z',
        status: 'CANCELLED',
        auditLogs: [
          {
            activity: 'Cancelled',
            description: '',
            editDate: '2024-11-13T04:00:49.968Z',
            editBy: '000000',
            editByName: 'System'
          },
          {
            activity: 'Created',
            description: null,
            editDate: '2024-11-12T10:24:13.912Z',
            editBy: '000031',
            editByName: 'Pk Qa'
          }
        ]
      },
      {
        requestNo: 'SB24-GX999999-000007',
        refDoc: 'SU24-000359',
        storeCode: 'GX999999',
        storeName: 'ขยันขาย',
        storeCodeName: 'GX999999-ขยันขาย',
        noOfItems: 2,
        requestedBy: 'Bilbilbil Bilbilbil',
        requestedDate: '2024-11-12T08:40:38.887Z',
        status: 'AWAITING_APPROVAL',
        auditLogs: [
          {
            activity: 'Created',
            description: null,
            editDate: '2024-11-12T08:40:38.202Z',
            editBy: '000050',
            editByName: 'Bilbilbil Bilbilbil'
          }
        ]
      },
      {
        requestNo: 'SB24-QAPOOKKY-000009',
        refDoc: 'SU24-000432',
        storeCode: 'QAPOOKKY',
        storeName: 'PookkyShop',
        storeCodeName: 'QAPOOKKY-PookkyShop',
        noOfItems: 4,
        requestedBy: 'Pookky Qa',
        requestedDate: '2024-11-12T02:59:53.776Z',
        status: 'APPROVED',
        auditLogs: [
          {
            activity: 'Approved',
            description: 'Approve',
            editDate: '2024-11-12T10:42:04.288Z',
            editBy: '000003',
            editByName: 'Admin Moo'
          },
          {
            activity: 'Approved',
            description: 'Approve',
            editDate: '2024-11-12T10:39:35.979Z',
            editBy: '000003',
            editByName: 'Admin Moo'
          },
          {
            activity: 'Created',
            description: null,
            editDate: '2024-11-12T02:59:53.234Z',
            editBy: '000030',
            editByName: 'Pookky Qa'
          }
        ]
      },
      {
        requestNo: 'SB24-QAPOOKKY-000008',
        refDoc: 'SU24-000419',
        storeCode: 'QAPOOKKY',
        storeName: 'PookkyShop',
        storeCodeName: 'QAPOOKKY-PookkyShop',
        noOfItems: 4,
        requestedBy: 'Pookky Qa',
        requestedDate: '2024-11-12T02:50:18.046Z',
        status: 'CANCELLED',
        auditLogs: [
          {
            activity: 'Cancelled',
            description: null,
            editDate: '2024-11-12T02:59:53.762Z',
            editBy: '000000',
            editByName: 'System'
          },
          {
            activity: 'Created',
            description: null,
            editDate: '2024-11-12T02:50:16.866Z',
            editBy: '000030',
            editByName: 'Pookky Qa'
          }
        ]
      },
      {
        requestNo: 'SB24-PANDA02-000003',
        refDoc: 'SU24-000291',
        storeCode: 'PANDA02',
        storeName: 'บ้านแพนด้าน่ารักจัง',
        storeCodeName: 'PANDA02-บ้านแพนด้าน่ารักจัง',
        noOfItems: 5,
        requestedBy: 'Dear Cjx',
        requestedDate: '2024-11-11T10:19:44.375Z',
        status: 'AWAITING_APPROVAL',
        auditLogs: [
          {
            activity: 'Created',
            description: null,
            editDate: '2024-11-11T10:19:44.099Z',
            editBy: '000028',
            editByName: 'Dear Cjx'
          }
        ]
      },
      {
        requestNo: 'SB24-QAPOOKKY-000007',
        refDoc: 'SU24-000367',
        storeCode: 'QAPOOKKY',
        storeName: 'PookkyShop',
        storeCodeName: 'QAPOOKKY-PookkyShop',
        noOfItems: 1,
        requestedBy: 'Pk Qa',
        requestedDate: '2024-11-11T07:15:55.153Z',
        status: 'AWAITING_APPROVAL',
        auditLogs: [
          {
            activity: 'Created',
            description: null,
            editDate: '2024-11-11T07:15:54.722Z',
            editBy: '000031',
            editByName: 'Pk Qa'
          }
        ]
      },
      {
        requestNo: 'SB24-QAPOOKKY-000006',
        refDoc: 'SU24-000423',
        storeCode: 'QAPOOKKY',
        storeName: 'PookkyShop',
        storeCodeName: 'QAPOOKKY-PookkyShop',
        noOfItems: 2,
        requestedBy: 'Pk Qa',
        requestedDate: '2024-11-08T10:33:55.482Z',
        status: 'CANCELLED',
        auditLogs: [
          {
            activity: 'Cancelled',
            description: null,
            editDate: '2024-11-11T08:35:36.609Z',
            editBy: '000000',
            editByName: 'System'
          },
          {
            activity: 'Created',
            description: null,
            editDate: '2024-11-08T10:33:55.063Z',
            editBy: '000031',
            editByName: 'Pk Qa'
          }
        ]
      },
      {
        requestNo: 'SB24-GX999999-000006',
        refDoc: 'SU24-000411',
        storeCode: 'GX999999',
        storeName: 'ขยันขาย',
        storeCodeName: 'GX999999-ขยันขาย',
        noOfItems: 11,
        requestedBy: 'Saranya Cj',
        requestedDate: '2024-11-08T09:40:11.753Z',
        status: 'AWAITING_APPROVAL',
        auditLogs: [
          {
            activity: 'Created',
            description: null,
            editDate: '2024-11-08T09:40:11.268Z',
            editBy: '000046',
            editByName: 'Saranya Cj'
          }
        ]
      },
      {
        requestNo: 'SB24-PANDA02-000002',
        refDoc: 'SU24-000408',
        storeCode: 'PANDA02',
        storeName: 'บ้านแพนด้าน่ารักจัง',
        storeCodeName: 'PANDA02-บ้านแพนด้าน่ารักจัง',
        noOfItems: 2,
        requestedBy: 'Dear Cjx',
        requestedDate: '2024-11-08T04:32:41.546Z',
        status: 'AWAITING_APPROVAL',
        auditLogs: [
          {
            activity: 'Created',
            description: null,
            editDate: '2024-11-08T04:32:41.108Z',
            editBy: '000028',
            editByName: 'Dear Cjx'
          }
        ]
      },
      {
        requestNo: 'SB24-QAPOOKKY-000005',
        refDoc: 'SU24-000404',
        storeCode: 'QAPOOKKY',
        storeName: 'PookkyShop',
        storeCodeName: 'QAPOOKKY-PookkyShop',
        noOfItems: 4,
        requestedBy: 'Pk Qa',
        requestedDate: '2024-11-08T04:12:18.614Z',
        status: 'CANCELLED',
        auditLogs: [
          {
            activity: 'Cancelled',
            description: null,
            editDate: '2024-11-11T08:35:36.601Z',
            editBy: '000000',
            editByName: 'System'
          },
          {
            activity: 'Created',
            description: null,
            editDate: '2024-11-08T04:12:18.550Z',
            editBy: '000031',
            editByName: 'Pk Qa'
          }
        ]
      },
      {
        requestNo: 'SB24-PANDA02-000001',
        refDoc: 'SU24-000326',
        storeCode: 'PANDA02',
        storeName: 'บ้านแพนด้าน่ารักจัง',
        storeCodeName: 'PANDA02-บ้านแพนด้าน่ารักจัง',
        noOfItems: 5,
        requestedBy: 'Dear Cjx',
        requestedDate: '2024-11-08T04:09:27.396Z',
        status: 'AWAITING_APPROVAL',
        auditLogs: [
          {
            activity: 'Created',
            description: null,
            editDate: '2024-11-08T04:09:27.214Z',
            editBy: '000028',
            editByName: 'Dear Cjx'
          }
        ]
      },
      {
        requestNo: 'SB24-QAPOOKKY-000004',
        refDoc: 'SU24-000374',
        storeCode: 'QAPOOKKY',
        storeName: 'PookkyShop',
        storeCodeName: 'QAPOOKKY-PookkyShop',
        noOfItems: 3,
        requestedBy: 'Pk Qa',
        requestedDate: '2024-11-07T10:28:33.871Z',
        status: 'AWAITING_APPROVAL',
        auditLogs: [
          {
            activity: 'Created',
            description: null,
            editDate: '2024-11-07T10:28:33.801Z',
            editBy: '000031',
            editByName: 'Pk Qa'
          }
        ]
      },
      {
        requestNo: 'SB24-QAPOOKKY-000003',
        refDoc: 'SU24-000374',
        storeCode: 'QAPOOKKY',
        storeName: 'PookkyShop',
        storeCodeName: 'QAPOOKKY-PookkyShop',
        noOfItems: 1,
        requestedBy: 'Pk Qa',
        requestedDate: '2024-11-07T10:28:25.418Z',
        status: 'CANCELLED',
        auditLogs: [
          {
            activity: 'Cancelled',
            description: null,
            editDate: '2024-11-07T10:28:33.865Z',
            editBy: '000031',
            editByName: 'Pk Qa'
          },
          {
            activity: 'Created',
            description: null,
            editDate: '2024-11-07T10:28:25.305Z',
            editBy: '000031',
            editByName: 'Pk Qa'
          }
        ]
      },
      {
        requestNo: 'SB24-QAPOOKKY-000002',
        refDoc: 'SU24-000376',
        storeCode: 'QAPOOKKY',
        storeName: 'PookkyShop',
        storeCodeName: 'QAPOOKKY-PookkyShop',
        noOfItems: 1,
        requestedBy: 'Pk Qa',
        requestedDate: '2024-11-07T10:22:28.165Z',
        status: 'AWAITING_APPROVAL',
        auditLogs: [
          {
            activity: 'Created',
            description: null,
            editDate: '2024-11-07T10:22:28.008Z',
            editBy: '000031',
            editByName: 'Pk Qa'
          }
        ]
      },
      {
        requestNo: 'SB24-QAPOOKKY-000001',
        refDoc: 'SU24-000375',
        storeCode: 'QAPOOKKY',
        storeName: 'PookkyShop',
        storeCodeName: 'QAPOOKKY-PookkyShop',
        noOfItems: 0,
        requestedBy: 'Pk Qa',
        requestedDate: '2024-11-07T04:11:53.078Z',
        status: 'AWAITING_APPROVAL',
        auditLogs: [
          {
            activity: 'Created',
            description: null,
            editDate: '2024-11-07T04:11:53.017Z',
            editBy: '000031',
            editByName: 'Pk Qa'
          }
        ]
      },
      {
        requestNo: 'SB24-QACJX038-000001',
        refDoc: 'SU24-000042',
        storeCode: 'QACJX038',
        storeName: 'STORE-POOK',
        storeCodeName: 'QACJX038-STORE-POOK',
        noOfItems: 8,
        requestedBy: 'Kapook Khamoo',
        requestedDate: '2024-11-07T03:40:11.536Z',
        status: 'AWAITING_APPROVAL',
        auditLogs: [
          {
            activity: 'Created',
            description: null,
            editDate: '2024-11-07T03:40:11.344Z',
            editBy: '000044',
            editByName: 'Kapook Khamoo'
          }
        ]
      },
      {
        requestNo: 'SB24-CJX12492-000001',
        refDoc: 'SU24-000366',
        storeCode: 'CJX12492',
        storeName: 'เจ้อ๋อ กิโล3',
        storeCodeName: 'CJX12492-เจ้อ๋อ กิโล3',
        noOfItems: 3,
        requestedBy: 'Tucjx Qa',
        requestedDate: '2024-11-06T08:36:53.600Z',
        status: 'AWAITING_APPROVAL',
        auditLogs: [
          {
            activity: 'Created',
            description: null,
            editDate: '2024-11-06T08:36:53.112Z',
            editBy: '000081',
            editByName: 'Tucjx Qa'
          }
        ]
      }
    ],
    page: 0,
    size: 20,
    totalElements: 25,
    first: true,
    last: false,
    hasContent: true,
    numberOfElements: 20,
    totalPages: 2,
    empty: false
  });
};

export const handlers = [
  http.get(env.serverUrl + envServiceUrl + '/view/' + 'SB24-QAPOOKKY-0000131', getStoreAvailableViewResolver),
  http.get(env.serverUrl + envServiceUrl + module.list, getStoreAvailableListResolver)
];
